import React from 'react';
import AddAlert from '@material-ui/icons/AddAlert';
import TableType2 from '../../../components/sharedComponents/Tablas/TableType2/TableType2';
import CardTitle from '../../../components/sharedComponents/CardTitle';
import Snackbar from '../../../components/sharedComponents/Snackbar/Snackbar';
import { permitsList } from '../../../constants/permits';

const LinesPage = (props) => {
  const {
    lines,
    onUpdate,
    loading,
    permisos,
  } = props;

  const columns = [
    { title: 'id', field: 'id', editable: 'never' },
    { title: 'Linea', field: 'linea', editable: 'never' },
    { title: 'Nombre Comercial', field: 'nombre_comercial' },
  ];

  return (
    <>
      <CardTitle
        title="Tablas Nombres Comerciales"
      />
      <Snackbar
        place="tr" // Depende la dirección en la que se va a mostrar
        color="warning"
        icon={AddAlert}
        message="Actualización en progreso...."
        open={loading}
      />
      <TableType2
        dataTable={lines}
        idPermiso={permitsList.SEGMENTACION_LINEAS}
        onUpdate={onUpdate}
        minValue={permisos[permitsList.SEGMENTACION_LINEAS]}
        columns={columns}
        loading={loading}
      />
    </>
  );
};

export default LinesPage;
